export const isStandalone = (): boolean => {
  return window.matchMedia('(display-mode: standalone)').matches;
};
